export default "__VITE_ASSET__Cpf7hafj__"